var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-start") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-Map",
    transform: "translate(-52.000000, -529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-marker-start",
    transform: "translate(52.000000, 529.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#010102",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 14,
    cy: 14,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,22 C14.2708333,22 14.5104167,21.90625 14.71875,21.71875 L14.71875,21.71875 L21.71875,14.71875 C21.90625,14.5104167 22,14.2708333 22,14 C22,13.7291667 21.90625,13.4895833 21.71875,13.28125 L21.71875,13.28125 L14.71875,6.28125 C14.5104167,6.09375 14.2708333,6 14,6 C13.7291667,6 13.4895833,6.09375 13.28125,6.28125 L13.28125,6.28125 L6.28125,13.28125 C6.09375,13.4895833 6,13.7291667 6,14 C6,14.2708333 6.09375,14.5104167 6.28125,14.71875 L6.28125,14.71875 L13.28125,21.71875 C13.4895833,21.90625 13.7291667,22 14,22 Z M12.25,16.5 L11.25,16.5 C11.0833333,16.5 11,16.4166667 11,16.25 L11,16.25 L11,13.75 C11,13.4791667 11.0989583,13.2447917 11.296875,13.046875 C11.4947917,12.8489583 11.7291667,12.75 12,12.75 L12,12.75 L15.5,12.75 L15.5,11.0625 C15.5,10.9583333 15.5520833,10.8854167 15.65625,10.84375 C15.7604167,10.8020833 15.84375,10.8125 15.90625,10.875 L15.90625,10.875 L18.5625,13.3125 C18.6875,13.4375 18.6875,13.5625 18.5625,13.6875 L18.5625,13.6875 L15.90625,16.125 C15.84375,16.1875 15.7604167,16.1979167 15.65625,16.15625 C15.5520833,16.1145833 15.5,16.0416667 15.5,15.9375 L15.5,15.9375 L15.5,14.25 L12.5,14.25 L12.5,16.25 C12.5,16.4166667 12.4166667,16.5 12.25,16.5 L12.25,16.5 Z",
    id: "\\uF5EB",
    fill: "#010102",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerStart);
export default __webpack_public_path__ + "static/media/map-marker-start.6767a9a2d8aee17d8774fc630562b51b.svg";
export { ForwardRef as ReactComponent };